import { gql } from '../../../../../__generated__/gql';


// export const LINK_PERSON_ON_PEOPLE_FRAGMENT = gql(`
//     fragment PeopleForLink__Person on Person {
//         id
//         firstName
//         middleName
//         lastName
//         jobTitle
//         email
//         startDate
//         endDate
//         expired
//         role {
//             name
//             normalizedName
//         }
//         students {
//             ...PeopleForLink__StudentFragment
//         }
//     }
// `);


export const LINK_PERSON_ON_STUDENTS_FRAGMET = gql(`
    fragment PeopleForLink__StudentFragment on StudentsConnection {
        pageInfo {
            hasNextPage
            hasPreviousPage
            startCursor
            endCursor
        }
        edges {
            cursor
            node {
                id
                firstName
                lastName
                dob
                references
            }
        }
        totalCount
    }
`)

export const SELECTED_PERSON_FRAGMENT = gql(`
    fragment SelectedPerson_Person on Person {
        id
        firstName
        middleName
        lastName
        jobTitle
        email
        startDate
        endDate
        expired
        role {
            name
            normalizedName
            clientFacingName
        }
        students {
            ...PeopleForLink__StudentFragment
        }
    }
    `)